<template>
  <div class="rework">
    <navbar title="返工管理"></navbar>
    <div class="flex1 workload flex-column h100">
      <div class="mt10">
        <el-card class="box-card">
          <div>
            <div class="inblock">
              <span class="demonstration">
                条形码 :
                <el-input v-model="from.barCode" placeholder="条形码输入" @keyup.enter.native='queryList'></el-input>
              </span>

            </div>
            <div class="inblock time">
              统计日期:
              <el-date-picker
                  v-model="time"
                  @change="DateChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="inblock time">
              <el-radio-group @change="radioChange" v-model="from.return_status">
                <el-radio label="2" checked>我发布的</el-radio>
                <el-radio label="1">我的返工</el-radio>
              </el-radio-group>

            </div>
          </div>
        </el-card>
      </div>
      <div class="flex1 mt10">
        <el-table
            :data="tableData"
            border
            style="width: 100%"
            :height="tableHeight"
            :row-class-name="tableRowClassName"
        >
          <el-table-column prop="find_member" label="发现员工" sortable></el-table-column>
          <el-table-column prop="return_member" label="返工员工"></el-table-column>
          <el-table-column prop="return_position" label="返工岗位"></el-table-column>
          <el-table-column prop="remarks" label="返工原因"></el-table-column>
          <el-table-column prop="code_num" label="条形码"></el-table-column>
          <el-table-column prop="create_time" label="返工时间"></el-table-column>
          <el-table-column prop="factory_position_id" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="AcknowledgeReceipt(scope.row)" size="small">确认接收</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
    import header from '@/components/header'
    export default {
        components: {
            navbar: header
        },
        data() {
            return {
                tableHeight: window.innerHeight - 200,
                time: [new Date(), new Date()],
                tableData: [],
                from: {
                    limit: 10,
                    barCode: "",
                    start_time: '',
                    end_time: '',
                    return_status: "2",
                    token: JSON.parse(localStorage.getItem("userInfo")).token
                }
            }
        },
        created() {
            this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
            this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D')
        },
        methods: {
            // 接收返工
            async AcknowledgeReceipt(row){
              console.log("ROW: ", row)
              let list = await this.$http.sureAccept({
                token: JSON.parse(localStorage.getItem("userInfo")).token,
                id: row.id
              });
              console.log("list: ", list)
            },
            tableRowClassName({ rowIndex }) {
                if (rowIndex % 2 == 0) {
                    return 'warning-row';
                }
                return '';
            },
            async queryList() {
                this.from.start_time = this.time[0];
                this.from.end_time	 = this.time[1];
                this.tableData = (await this.$http.returnList(this.from)).data.data.data;
                console.log("this.tableData ------: ", this.tableData)
            },
            // 时间被选择的时候，发送ajax
            DateChange() {
                this.queryList();
            },
            // 单选被选择时候，发送ajax
            radioChange() {
                this.queryList();
            }
        },
        name: "ReworkManagement"
    }
</script>

<style scoped lang="less">
  .el-input {
    width: auto !important;
  }
  .time {
    margin-left: 40px;
  }
</style>